module.exports = __webpack_public_path__ + "media/images/partners/uncdf-753951d47915144488f24785e8de454b.png";